export default __webpack_public_path__ + "img/cdbe2fe5b027640240421d7889f75ff3.svg";